import React from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
//@ts-ignore cortex
import { useQueryString } from "@cortexglobal/cortex-utilities";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    PageTitle,
    Row,
    Panel,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
import EventCategoryForm, {
    EventCategory,
} from "../../../forms/EventCategoryForm";

export const EventCategoryCreate = ({ path }) => {
    const history = useHistory();
    //parent_id will be set if it's in the URL otherwise it's null which is what we want
    const parent_id = useQueryString().get("parent_id");

    const item: EventCategory = {
        locale: "",
        name: "",
        description: "",
        color: null,
        thumbnail: null,
    };

    const submitForm = (values) => {
        return axios
            .post(`/api/v1/admin/event-category`, values)
            .then(({ data }) => {
                if (parent_id !== null) {
                    history.goBack();
                }
                //As creation was successful move them on to the appropriate listing page
                history.push(`${path}`);
            });
    };
    return (
        <div>
            <PageTitle title={<>{trans("New Event Category")}</>}>
                <IconTextButton
                    as={Link}
                    to={path}
                    rotation={180}
                    showCircle={false}
                    expanded={false}
                >
                    {trans("Back to listing")}
                </IconTextButton>
            </PageTitle>

            <Row>
                <Panel>
                    <EventCategoryForm item={item} submitForm={submitForm} />
                </Panel>
            </Row>
        </div>
    );
};

export default EventCategoryCreate;
